// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/applications.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { ApplicationService } from "./applications_pb";

/**
 * CreateApplication creates a new ArgoCD application
 *
 * @generated from rpc catpocs.v1.ApplicationService.CreateApplication
 */
export const createApplication = ApplicationService.method.createApplication;

/**
 * GetApplication retrieves an application by ID
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetApplication
 */
export const getApplication = ApplicationService.method.getApplication;

/**
 * ListApplications lists all applications in a project
 *
 * @generated from rpc catpocs.v1.ApplicationService.ListApplications
 */
export const listApplications = ApplicationService.method.listApplications;

/**
 * DeleteApplication soft-deletes an application and triggers ArgoCD CRD deletion
 *
 * @generated from rpc catpocs.v1.ApplicationService.DeleteApplication
 */
export const deleteApplication = ApplicationService.method.deleteApplication;

/**
 * SyncApplication triggers a sync for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.SyncApplication
 */
export const syncApplication = ApplicationService.method.syncApplication;

/**
 * UpdateApplicationSyncPolicy updates the sync policy for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.UpdateApplicationSyncPolicy
 */
export const updateApplicationSyncPolicy = ApplicationService.method.updateApplicationSyncPolicy;

/**
 * SuspendApplication disables automated sync for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.SuspendApplication
 */
export const suspendApplication = ApplicationService.method.suspendApplication;

/**
 * ResumeApplication re-enables automated sync for a suspended application
 *
 * @generated from rpc catpocs.v1.ApplicationService.ResumeApplication
 */
export const resumeApplication = ApplicationService.method.resumeApplication;

/**
 * RetryCreateCRD retries creating the ArgoCD CRD for an application with crd_error
 *
 * @generated from rpc catpocs.v1.ApplicationService.RetryCreateCRD
 */
export const retryCreateCRD = ApplicationService.method.retryCreateCRD;

/**
 * RetryHelmValidation retries Helm validation for a failed application
 *
 * @generated from rpc catpocs.v1.ApplicationService.RetryHelmValidation
 */
export const retryHelmValidation = ApplicationService.method.retryHelmValidation;

/**
 * RetryApplicationSetup retries setup for RepoValidationFailed or AWSProvisioningFailed (e.g. after installing GitHub App on repo)
 *
 * @generated from rpc catpocs.v1.ApplicationService.RetryApplicationSetup
 */
export const retryApplicationSetup = ApplicationService.method.retryApplicationSetup;

/**
 * StartApplicationValidation triggers Helm validation from Created state
 *
 * @generated from rpc catpocs.v1.ApplicationService.StartApplicationValidation
 */
export const startApplicationValidation = ApplicationService.method.startApplicationValidation;

/**
 * ForceDeleteApplication hard-deletes an application (project admin only - for stuck deletions)
 *
 * @generated from rpc catpocs.v1.ApplicationService.ForceDeleteApplication
 */
export const forceDeleteApplication = ApplicationService.method.forceDeleteApplication;

/**
 * UpsertApplicationGitHubVariables creates/updates GitHub Actions repository variables for this application.
 *
 * @generated from rpc catpocs.v1.ApplicationService.UpsertApplicationGitHubVariables
 */
export const upsertApplicationGitHubVariables = ApplicationService.method.upsertApplicationGitHubVariables;

/**
 * GetApplicationEvents retrieves Kubernetes events for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetApplicationEvents
 */
export const getApplicationEvents = ApplicationService.method.getApplicationEvents;

/**
 * GetApplicationDiff retrieves the diff between desired and live state
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetApplicationDiff
 */
export const getApplicationDiff = ApplicationService.method.getApplicationDiff;

/**
 * GetDeploymentHistory retrieves deployment history for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetDeploymentHistory
 */
export const getDeploymentHistory = ApplicationService.method.getDeploymentHistory;

/**
 * GetApplicationTrafficMetrics retrieves Traefik traffic metrics for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetApplicationTrafficMetrics
 */
export const getApplicationTrafficMetrics = ApplicationService.method.getApplicationTrafficMetrics;

/**
 * GetApplicationResourceStatus retrieves detailed resource status (pods, events) for an application
 *
 * @generated from rpc catpocs.v1.ApplicationService.GetApplicationResourceStatus
 */
export const getApplicationResourceStatus = ApplicationService.method.getApplicationResourceStatus;

/**
 * ListApplicationsWithIssues lists all applications that have issues (out of sync, degraded, CRD errors)
 *
 * @generated from rpc catpocs.v1.ApplicationService.ListApplicationsWithIssues
 */
export const listApplicationsWithIssues = ApplicationService.method.listApplicationsWithIssues;

/**
 * ListApplicationSetupAttempts returns durable setup attempt history for an application.
 *
 * @generated from rpc catpocs.v1.ApplicationService.ListApplicationSetupAttempts
 */
export const listApplicationSetupAttempts = ApplicationService.method.listApplicationSetupAttempts;
